import $ from 'jquery';
import { Component, ChangeDetectionStrategy, OnInit, ElementRef, OnDestroy } from '@angular/core';

@Component({
  selector: 'thankyou-modal',
  templateUrl: './thankyou-modal.component.html',
  styleUrls: ['./thankyou-modal.component.scss', '../../styles/upgrade.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThankyoudModalComponent implements OnInit, OnDestroy {
  public el: HTMLElement;
  public $modal: any;

  constructor(elRef: ElementRef) {
    this.el = elRef.nativeElement;
  }

  public ngOnInit(): void {
    this.$modal = $(this.el.querySelector('.ui.modal'));
  }

  public show(): void {
    this.$modal.modal('show');
  }

  public ngOnDestroy(): void {
    this.$modal.modal('hide');
    this.$modal.modal('destroy');
    this.$modal.remove();
  }
}
